import React from 'react';
import { usePlanoForm } from './Context';
import { PlanoCard } from './PlanoCard';
import moment from 'moment';

const PlanoFormHorarios = () => {
    const { plano, servicesOptions, startAt } = usePlanoForm();

    return (
        <div className="space-y-6">
            <label className="form-control">
                <div className="label">
                    <span className="label-text">Início</span>
                </div>
                <input
                    type="date"
                    value={moment(startAt).format('YYYY-MM-DD')}
                    className="input input-bordered w-min"
                />
            </label>

            <div>
                <div className="text-sm">
                    Duração: {plano?.durationInMonths?.toString()} meses
                </div>

                <div className="space-y-4">
                    {plano?.services?.map((item: any) => {
                        const label = servicesOptions?.find((e: any) => e.value === item.serviceId)?.label;

                        return (
                            <div key={item.serviceId} className="p-4 rounded-xl bg-base-100 shadow">
                                <h3 className="font-bold text-lg">{label}</h3>
                                <p className="text-xs mb-3">
                                    {item.quantity} agendamentos mensal
                                </p>

                                <PlanoCard
                                    serviceId={item.serviceId}
                                    recurrence={item.quantity}
                                />
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default PlanoFormHorarios;
